export enum ToolTipMessages {
    INITIATE_DISABLE = 'Enable when "Send for approval"\n request is approved',
  }
  